import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

import { useSupportData } from '../core/hooks/use-support-data';

/** Keep the support experience decision out of account consumers. */
export const useHelpLinkUrlGenerator = (rbiOrderId: string) => {
  const enablePypestream = useFlag(LaunchDarklyFlag.ENABLE_PYPESTREAM);
  const { orderingIssuesCategoryGroup } = useSupportData();
  const categoryId = orderingIssuesCategoryGroup?._id;
  const formUrl = `${routes.supportCategories}/${categoryId ?? ''}?orderId=${rbiOrderId}`;
  const chatUrl = rbiOrderId ? `${routes.support}?orderId=${rbiOrderId}` : routes.support;

  return enablePypestream ? chatUrl : formUrl;
};
